<template>
  <v-card class="ui-module-card rounded-sm" color="primary">
    <v-card-text>
      <v-container>
        <v-form ref="form">
          <v-row>
            <v-col cols="4">
              <v-select
                class="ui-form-field"
                v-model="remesa.fk_idLoc"
                :items="locOptions"
                item-value="idLoc"
                item-text="displayText"
                rounded
                filled
                dense
                background-color="transparent"
                color="secondary"
              >
                <template v-slot:label>ID loc</template>
              </v-select>
            </v-col>
            <v-col cols="4">
              <v-menu
                v-model="menuFechaAlta"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    class="ui-form-field"
                    v-model="fechaAltaFormatted"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="transparent"
                    hint="Formato de fecha: DD/MM/YYYY"
                    :rules="[rules.required]"
                  >
                    <template v-slot:label>Fecha alta <span class="red--text">*</span></template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="remesa.fechaAlta"
                  @input="menuFechaAlta = false"
                  locale="es"
                  no-title
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="4">
              <v-menu
                v-model="menuFechaTramite"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    class="ui-form-field"
                    v-model="fechaTramiteFormatted"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="transparent"
                    hint="Formato de fecha: DD/MM/YYYY"
                    :rules="[rules.required]"
                  >
                    <template v-slot:label>Fecha de trámite <span class="red--text">*</span></template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="remesa.fechaTramite"
                  @input="menuFechaTramite = false"
                  locale="es"
                  no-title
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12">
              <v-text-field
                class="ui-form-field"
                v-model="remesa.numOficio"
                label="Número de oficio"
                rounded
                filled
                dense
                color="secondary"
                background-color="transparent"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions class="justify-center ui-module-actions">
      <TextButton :loading="loading" @click="guardarCambios"> Guardar cambios </TextButton>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import TextButton from '@/components/base/TextButton.vue'
import moment from 'moment'

export default {
  components: {
    TextButton,
  },

  props: {
    remesaSeleccionada: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      menuFechaAlta: false,
      menuFechaTramite: false,
      rules: {
        required: (v) => !!v || 'Campo obligatorio',
      },
      remesa: {
        fk_idLoc: 0,
        fechaAlta: '',
        fechaTramite: '',
        numOficio: '',
      },
    }
  },

  computed: {
    ...mapGetters('licenciaOficialColectiva', {
      locs: 'getLocs',
    }),
    locOptions() {
      return this.locs.map((loc) => ({
        idLoc: loc.idLoc,
        displayText: `${loc.noLicencia}`,
      }))
    },
    fechaAltaFormatted: {
      get() {
        return this.remesa.fechaAlta ? moment(this.remesa.fechaAlta).format('DD/MM/YYYY') : ''
      },
      set(value) {
        const date = moment(value, 'DD/MM/YYYY', true)
        this.remesa.fechaAlta = date.isValid() ? date.toDate() : null
      },
    },
    fechaTramiteFormatted: {
      get() {
        return this.remesa.fechaTramite ? moment(this.remesa.fechaTramite).format('DD/MM/YYYY') : ''
      },
      set(value) {
        const date = moment(value, 'DD/MM/YYYY', true)
        this.remesa.fechaTramite = date.isValid() ? date.toDate() : null
      },
    },
  },

  methods: {
    ...mapActions('remesas', ['updateRemesa']),
    async guardarCambios() {
      const valid = await this.$refs.form.validate()
      if (!valid) return
      this.loading = true
      try {
        const payload = {
          fk_idLoc: this.remesa.fk_idLoc,
          fechaAlta: this.remesa.fechaAlta ? moment(this.remesa.fechaAlta).format('YYYY-MM-DD') : '',
          fechaTramite: this.remesa.fechaTramite ? moment(this.remesa.fechaTramite).format('YYYY-MM-DD') : '',
          numOficio: this.remesa.numOficio,
        }
        await this.updateRemesa({
          payload,
          idRemesa: this.remesaSeleccionada.idRemesa,
        })
        this.$emit('close')
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
  },

  created() {
    if (this.remesaSeleccionada) {
      this.remesa = {
        ...this.remesaSeleccionada,
        fechaAlta: this.remesaSeleccionada.fechaAlta
          ? moment(this.remesaSeleccionada.fechaAlta, 'YYYY-MM-DD').toDate()
          : null,
        fechaTramite: this.remesaSeleccionada.fechaTramite
          ? moment(this.remesaSeleccionada.fechaTramite, 'YYYY-MM-DD').toDate()
          : null,
      }
    }
  },
}
</script>

<style scoped>
.ui-module-card {
  background: rgba(30, 30, 46, 0.6) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(108, 92, 231, 0.2);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

::v-deep .ui-form-field .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(108, 92, 231, 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
}

::v-deep .ui-form-field .v-input__slot:hover {
  border-color: rgba(108, 92, 231, 0.45) !important;
}

::v-deep .ui-form-field .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-input__control {
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field input,
::v-deep .ui-form-field .v-select__selection,
::v-deep .ui-form-field .mdi-menu-down {
  color: #e0e0e0 !important;
}

::v-deep .ui-form-field .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-label {
  color: #a29bfe !important;
}

::v-deep .ui-module-actions .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
}
</style>
